import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateInvoiceQueries } from '@/modules/common/utils/query-invalidation';

import { retryInvoice } from '../api';

export const useRetryInvoice = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.invoices');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (invoiceId: number) => retryInvoice(invoiceId),
    onSuccess: async () => {
      await invalidateInvoiceQueries(queryClient);
      displayToastSuccess(t('toasts.retrySuccess'));
      onSuccess?.();
    },
    onError: error =>
      displayToastErrorFromApiWithFallback(error, 'authenticated.invoices:toasts.retryError'),
  });
};
